import './loadingStyles.css';

export default function LoadingBlock({
  height = '100%',
  width = '100%',
  className = '',
}: {
  height?: string;
  width?: string;
  className?: string;
}) {
  if (className) {
    height = '0';
  }
  return (
    <div
      className={`load max-w-full ${className}`}
      style={{ paddingTop: height, width }}
    >
      <div />
    </div>
  );
}
